export class Profile {
  Id_Profile = 0;
  ProfileDescription = '';
  Id_Application = 0;
  ApplicationName = '';
  Id_Tag = 0;
  TagDescription = '';
}
